// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e0659f7c","455":"f09f5172"}[chunkId] + ".chunk.js";
};